<template>
    <div class="flypost">
        <filters :scope="filtersScope">
        </filters>
        <ConversionsTabs></ConversionsTabs>
        <div class="animated fadeIn">
          <form @submit="checkForm" id="formRent">
          <div class="row">
              <div class="col-md-12">
                  <div class="card-header-title">
                      <button class="btn btn-success btn-lg btn-check" style="float: right">
                          <i class="fa fa-check-circle"></i>
                          Сохранить
                      </button>
                  </div>
              </div>
          </div>
          <div class="card-block" v-if="loading">
              <div class="row">
                  <div class="col-md-12" >
                      <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                          <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                      </div>
                  </div>
              </div>
          </div>
          <div class="exelAll" style="overflow:hidden; width:100%" v-else>
              <div :key="indexYear" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" id="swipe1" style="display:flex;flex-wrap: nowrap;" v-for="(indexMonth,indexYear) in totalAllColumns" v-hammer:pan="onSwipe">
                  <div :key="`${indexYear}_${indexCourier}`" style="flex: 0 0 880px;" v-for="(rowsMonth,indexCourier,index) in indexMonth">
                      <div class=" statistic-table" style="margin-bottom:0; " >
                          <div class="card-header">
                              {{month[indexCourier - 1]}} {{indexYear}} г.<br/>
                          </div>

                          <StatisticTable :className="`${[indexYear]}-${month[indexCourier - 1]}`"
                                          :classes="`${[indexYear]}-${[month[indexCourier - 1]]}`"
                                          :footColumns="totalAllColumns[indexYear][indexCourier][0]"
                                          :isFlypost="true"
                                          :isExelAll="true"
                                          :headColumns="headColumnsFlyPost"
                                          :rows="[]"
                                          @isPopupFlyPost="isPopupFlyPost"
                                          :isFlypostModal="true"
                                          @exportingAll="exportingAll"
                                          :totalColumnsDd="totalCourier[indexYear][indexCourier]"
                                          :title="`${$t('statistic.in_total')}`"
                                          >
                          </StatisticTable>
                      </div>
                  </div>
              </div>
              <div :key="indexYear" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" id="swipe" v-for="(rowsCourier,indexYear) in rows" v-hammer:pan="onSwipe">
                  <div :key="`${indexYear}_${indexCourier}`" style="display:flex;flex-wrap: nowrap;" v-for="(rowsMonth,indexCourier,index) in rowsCourier">
                      <div :key="`${indexYear}_${indexCourier}_${indexMonth}`" style="flex: 0 0 880px;"  v-for="(rowsData, indexMonth) in rowsMonth">
                          <div v-if="rowsData.length !== 0">
                              <div class=" statistic-table" style="margin-bottom:0; " >
                                  <StatisticTable :className="`${[indexYear]}-${[indexMonth]}`"
                                                  :footColumns="footColumns[indexYear][indexCourier][indexMonth][0]"
                                                  :headColumns="headColumns"
                                                  :rows="rowsData"
                                                  :isFlypostModal="true"
                                                  @isPopup="isPopup"
                                                  :title="`${Helper.getOfferTitle(Storage.offers, indexCourier)}`"
                                  >
                                  </StatisticTable>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </form>
        </div>

        <modal v-model="branchStatistics" large effect="fade/zoom">
            <div slot="modal-header" class="modal-header modal-header_popup">
        </div>
            <StatisticTable
                            :headColumns="headColumnsPopup"
                            :rows="rowsDataPopup"
                            :footColumns="footColumnsPopup"
                            :title="this.popupTitle"
                            >
            </StatisticTable>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-info" @click="branchStatistics = false"> {{ $t('verbs.close') }}</button>
            </div>
        </modal>
    </div>
</template>

<script>
import Filters from '../../../components/Filters.vue'
import FileSaver from 'file-saver'
import ConversionsTabs from './ConversionsTabs.vue'
import API from '../../../api/API'
import Storage from '../../../api/Storage'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import { modal } from 'vue-strap'
import { map, isNaN } from 'lodash'
import StatisticTable from '../../../components/StatisticTable.vue'

export default {
  name: 'Flypost',
  components: {
    Filters,
    ConversionsTabs,
    StatisticTable,
    modal
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      Storage: Storage,
      branchStatistics: false,
      TypeColor: TypeColor,
      Helper: Helper,
      loading: false,
      country: null,
      headColumnsFlyPost: [
        {label: this.$root.$t('statistic.city'), field: 'offer', width: '100px'},
        {label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '105px'},
        {label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '90px'},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '100px'},
        {label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '90px'},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '80px'},
        {label: this.$root.$t('statistic.cost_price'), field: 'cost_price', width: '80px'},
        {label: 'Изм.', field: 'shift', width: '75px'}
      ],
      headColumns: [
        {label: this.$root.$t('statistic.city'), field: 'offer', width: '100px'},
        {label: this.$root.$t('statistic.total'), field: 'total', colspan: 2, width: '105px'},
        {label: this.$root.$t('statistic.delivered'), field: 'delivered', width: '90px'},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2, width: '100px'},
        {label: this.$root.$t('statistic.shippeds'), field: 'shipped', width: '90px'},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout', width: '80px'},
        {label: this.$root.$t('statistic.cost_price'), field: 'cost_price', width: '80px'},
        {label: 'Изм.', field: 'shift', width: '75px'}
      ],
      headColumnsPopup: [
        {label: this.$root.$t('statistic.city'), field: 'offer'},
        {label: this.$root.$t('statistic.total'), field: 'total', colspan: 2},
        {label: this.$root.$t('statistic.delivered'), field: 'delivered'},
        {label: this.$root.$t('statistic.averageBillPopup'), field: 'averageBillPopup'},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
        {label: this.$root.$t('statistic.shippeds'), field: 'shipped'},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout'}
      ],
      month: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ],
      rows: [],
      rowsDataPopup: [],
      rowsTotal: [],
      footColumns: {},
      footColumnsPopup: {},
      summary: {},
      totalAllColumns: {},
      offers: [],
      totalCourier: {},
      x: 0,
      dataForExel: '',
      popupTitle: '',
      popupTitleTable: '',
      clickFlyPost: null
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const offset1 = document.getElementById('swipe1').offsetWidth
      const scroll1 = document.getElementById('swipe1').scrollWidth
      const width = scroll - offset
      const width1 = scroll1 - offset1
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }

        if (width1 > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10
          } else {
            this.x -= e.distance / 10
          }
          if (this.x > 0) {
            this.x = 0
          }
          if (Math.abs(this.x) > width1) {
            this.x = -width1
          }
        }
      }
    },
    checkForm: function (e) {
      let post = []
      let additional6, country, indexOfMonth, indexOfYear, offer, lengthOfId
      map(e.target, elem => {
        if (elem.name) {
          offer = elem.id.substring(0, 4)
          indexOfYear = elem.id.substring(5, 9)
          lengthOfId = elem.id.length
          indexOfMonth = elem.id.substring(10, lengthOfId)
          if (indexOfMonth >= 1 && indexOfMonth <= 9) {
            indexOfMonth = `0${indexOfMonth}`
          }
          additional6 = elem.name
          country = Storage.selectedCountry.id
          post.push({
            'country_id': country,
            'additional6': additional6,
            'cost': elem.value,
            'month': `${indexOfYear}-${indexOfMonth}`,
            'offer_id': offer
          })
        }
      })
      this.loading = true
      API.postConversionsFlypost(post).then(res => {
        this.calculateRows()
        this.loading = false
      })
        .catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      e.preventDefault()
    },
    isNumeric (x) {
      return ((typeof x === 'number' || typeof x === 'string') && !isNaN(Number(x)))
    },
    calculateRows () {
      this.rows = []
      this.footColumns = {}
      this.$root.$emit('data_loading')
      this.loading = true
      API.getConversionsFlypost().then(response => {
        this.rows = this.statisticData(response.body)
        this.loading = false
        this.$root.$emit('data_loaded')
      }).catch(response => {
        this.loading = false
        this.$notify({
          type: 'danger',
          title: this.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        })
      })
    },
    statisticData (rows) {
      let newRows = {}
      let totalDeliveredCount1 = {}
      let years = []
      this.footColumns = {}
      this.totalAllColumns = {}
      let totalSum, deliveredSum, returnSum, shippedSum, costSum
      let allColumnsTotal, allColumnsDelivered, allColumnsReturn, allColumnsShipped, allColumnsCost
      let arrayMonth = []
      map(rows, (rowsMonth, indexYear) => {
        if (!newRows[indexYear]) {
          newRows[indexYear] = {}
          this.footColumns[indexYear] = {}
          this.totalAllColumns[indexYear] = {}
        }
        years.push(indexYear)
        totalDeliveredCount1 = { [indexYear]: {}, rowsMonth, years }
        map(rowsMonth, (rowsCourier, indexMonth) => {
          /* this.totalDeliveredCount = {} */
          arrayMonth.push(indexMonth)
          totalDeliveredCount1[indexYear] = {
            [indexMonth]: {},
            ...totalDeliveredCount1[indexYear]
          }
          this.dataForExel = `${indexYear}-${indexMonth}`
          for (let courierIndex in rowsCourier) {
            Object.keys(rowsCourier[courierIndex]).map(courierKey => {
              totalDeliveredCount1[indexYear][indexMonth] = {
                [courierKey]: {
                  courier_name: courierKey,
                  total: 0,
                  delivered: 0,
                  refunded: 0,
                  shipped: 0,
                  cost: 0
                },
                ...totalDeliveredCount1[indexYear][indexMonth]
              }
            })
          }
          if (!this.totalAllColumns[indexYear][indexMonth]) {
            this.totalAllColumns[indexYear][indexMonth] = []
            allColumnsTotal = 0
            allColumnsDelivered = 0
            allColumnsReturn = 0
            allColumnsShipped = 0
            allColumnsCost = 0
          }
          map(rowsCourier, (rowsData, indexCourier) => {
            if (!newRows[indexYear][indexCourier]) {
              newRows[indexYear][indexCourier] = {}
              this.footColumns[indexYear][indexCourier] = {}
            }
            if (!newRows[indexYear][indexCourier][indexMonth]) {
              newRows[indexYear][indexCourier][indexMonth] = []
              this.footColumns[indexYear][indexCourier][indexMonth] = []
            }
            map(arrayMonth, perMonth => {
              if (!newRows[indexYear][indexCourier][perMonth]) {
                newRows[indexYear][indexCourier][perMonth] = []
                this.footColumns[indexYear][indexCourier][perMonth] = []
              }
            })
            totalSum = 0
            deliveredSum = 0
            returnSum = 0
            shippedSum = 0
            costSum = 0
            map(rowsData, (rowsOfferTotal, i) => {
              totalSum += parseInt(rowsOfferTotal.total)
              deliveredSum += parseInt(rowsOfferTotal.delivered)
              costSum += Number(rowsOfferTotal.cost)
              if (rowsOfferTotal.refunded) {
                returnSum += parseInt(rowsOfferTotal.refunded)
              }
              shippedSum += parseInt(rowsOfferTotal.shipped)
              if (rowsOfferTotal.percent_rate > 0) {
              }
            })
            allColumnsTotal += parseInt(totalSum)
            allColumnsDelivered += parseInt(deliveredSum)
            allColumnsReturn += parseInt(returnSum)
            allColumnsShipped += parseInt(shippedSum)
            allColumnsCost += Number(costSum)
            map(rowsData, (rowsOffer, i) => {
              newRows[indexYear][indexCourier][indexMonth].push({
                city: {
                  value: `${i}`,
                  popup: true,
                  indexCourier: indexCourier,
                  indexMonth: indexMonth
                },
                total: {
                  value: rowsOffer.total,
                  bg: true
                },
                totalPercent: {
                  value: Helper.percents(totalSum, rowsOffer.total),
                  bgg: Helper.renderGistPart(totalSum, rowsOffer.total, true)
                },
                delivered: {
                  value: rowsOffer.delivered,
                  bg: true
                },
                return: {
                  value: rowsOffer.refunded,
                  bg: true
                },
                returnPercents: {
                  value: Helper.percents(parseFloat(rowsOffer.approved), rowsOffer.refunded),
                  bgg: Helper.renderGistPart(rowsOffer.approved, rowsOffer.refunded, true)
                },
                shipped: {
                  value: rowsOffer.shipped,
                  bg: true
                },
                buyout: {
                  value: `${rowsOffer.percent_rate}%`,
                  bg: true
                },
                cost_price: {
                  htmlValue: '<input class="cellInput" id="' + indexCourier + '-' + indexYear + '-' + indexMonth + '" name="' + i + '" type="text" onchange="" value="' + rowsOffer.cost + '" >',
                  oldvalue: rowsOffer.cost,
                  name: i,
                  notupdate: true,
                  orderData: parseInt(rowsOffer.cost)
                },
                shift: {
                  value: `${(rowsOffer.percent_rate - rowsOffer.old_buyout_percent).toFixed(2)}%`,
                  bg: true
                }
              })
            })
            this.footColumns[indexYear][indexCourier][indexMonth].push({
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              total: {
                value: totalSum
              },
              totalPercent: {
                value: ``
              },
              delivered: {
                value: deliveredSum
              },
              return: {
                value: returnSum
              },
              returnPercents: {
                value: `${parseFloat((returnSum / totalSum) * 100).toFixed(0)}%`
              },
              shipped: {
                value: shippedSum
              },
              buyout: {
                value: `${Helper.percents(totalSum, deliveredSum)}`,
                bg: true
              },
              cost_price: {
                value: costSum,
                bg: true
              },
              shift: {
                value: ``
              }
            })
          })
          this.totalAllColumns[indexYear][indexMonth].push({
            label: {
              value: this.$root.$t('statistic.in_total'),
              width: '14%'
            },
            total: {
              value: allColumnsTotal,
              width: '10%'
            },
            totalPercent: {
              value: ``,
              width: '13%'
            },
            delivered: {
              value: allColumnsDelivered,
              width: '15%'
            },
            return: {
              value: allColumnsReturn,
              width: '5%'
            },
            returnPercents: {
              value: `${parseFloat((allColumnsReturn / allColumnsTotal) * 100).toFixed(0)}%`,
              width: '9%'
            },
            shipped: {
              value: allColumnsShipped,
              width: '12%'
            },
            buyout: {
              value: `${Helper.percents(allColumnsTotal, allColumnsDelivered)}`,
              bg: true,
              width: '10%'
            },
            cost_price: {
              value: allColumnsCost,
              bg: true,
              width: '15%'
            },
            shift: {
              value: ``,
              width: '11%'
            }
          })
        })
      })
      if (totalDeliveredCount1.years) {
        totalDeliveredCount1.years.map(year => {
          for (let key in totalDeliveredCount1.rowsMonth) {
            let month = key
            let company = totalDeliveredCount1.rowsMonth[key]
            for (let key in company) {
              Object.keys(company[key]).map(courierId => {
                totalDeliveredCount1[year][month][courierId].total += parseInt(company[key][courierId].total)
                totalDeliveredCount1[year][month][courierId].delivered += parseInt(company[key][courierId].delivered)
                totalDeliveredCount1[year][month][courierId].refunded += parseInt(company[key][courierId].refunded)
                totalDeliveredCount1[year][month][courierId].shipped += parseInt(company[key][courierId].shipped)
                if (company[key][courierId].cost) {
                  totalDeliveredCount1[year][month][courierId].cost += parseInt(company[key][courierId].cost)
                }
                totalDeliveredCount1[year][month][courierId].returnPercents = `${parseFloat((totalDeliveredCount1[year][month][courierId].refunded / totalDeliveredCount1[year][month][courierId].total) * 100).toFixed(0)}%`
                totalDeliveredCount1[year][month][courierId].buyout = `${Helper.percents(totalDeliveredCount1[year][month][courierId].total, totalDeliveredCount1[year][month][courierId].delivered)}`
                totalDeliveredCount1[year][month][courierId].totalPercents = this.totalAllColumns[year][month][0].total.value
                totalDeliveredCount1[year][month][courierId].month = month
              })
            }
          }
        })
      }
      this.totalCourier = totalDeliveredCount1
      return newRows
    },
    exportingAll () {
      const classes = document.getElementsByClassName('exelAll')
      let doc = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${this.title}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>`
      map(classes, (cl, i) => {
        doc += `${cl.innerHTML}<br/>`
      })
      doc += '</body></html>'
      FileSaver.saveAs(new Blob([doc], {
        encoding: 'UTF-8',
        type: 'application/octet-stream'
      }), `analytics-${this.dataForExel}.xls`)
      console.log(doc, 'doc')
    },
    isPopup (cell) {
      let nch = Storage.selectedCountry.rate
      let indexCourier = parseInt(cell.indexCourier)
      let indexCourierTitle = Helper.getOfferTitle(Storage.offers, cell.indexCourier)
      this.rowsDataPopup = []
      this.footColumnsPopup = {}
      this.popupTitle = indexCourierTitle + ' — ' + cell.value
      let totalSumModal
      const get = new Promise(function (resolve) {
        API.getBranch(cell.value, indexCourier, cell.indexMonth).then(response => {
          resolve(response.body)
        })
      })
      get.then(response => {
        map(response, (rowsMonth, indexYear) => {
          map(rowsMonth, (rowsBranch) => {
            map(rowsBranch, (data) => {
              totalSumModal = 0
              for (let i in data) {
                let value = data[i]
                totalSumModal += parseInt(value.total)
                this.rowsDataPopup.push({
                  offer: {
                    value: `${i}`
                  },
                  total: {
                    value: value.total
                  },
                  totalPercent: {
                    value: Helper.percents(totalSumModal, value.total),
                    bgg: Helper.renderGistPart(totalSumModal, value.total, true)
                  },
                  delivered: {
                    value: value.delivered
                  },
                  averageBillPopup: {
                    value: Helper.averageBillDay(value.average_bill, nch)
                  },
                  return: {
                    value: value.refunded
                  },
                  returnPercents: {
                    value: Helper.percents(parseFloat(value.approved), value.refunded),
                    bgg: Helper.renderGistPart(value.approved, value.refunded, true)
                  },
                  shipped: {
                    value: value.shipped
                  },
                  buyout: {
                    value: Helper.percents(value.approved, value.paid)
                  }
                })
              }
            })
          })
        })
      })
      this.branchStatistics = true
    },
    isPopupFlyPost (cell) {
      this.rowsDataPopup = []
      this.footColumnsPopup = {}
      this.popupTitle = cell.courier_name
      let totalSumModal = 0
      let totalSumDelivered = 0
      let totalSumAverageBill = 0.0
      let totalSumAccepted = 0
      let totalSumReturn = 0
      let totalSunShipped = 0
      const get = new Promise(function (resolve) {
        API.getBranchSum(cell.courier_name, cell.month).then(response => {
          resolve(response.body)
        })
      })
      get.then(response => {
        map(response, (rowsMonth, indexYear) => {
          map(rowsMonth, (rowsBranch) => {
            map(rowsBranch, (data) => {
              for (let i in data) {
                let value = data[i]
                value.forEach(item => {
                  totalSumModal += parseInt(item.total)
                  totalSumDelivered += parseInt(item.delivered)
                  if (item.approved) {
                    totalSumAccepted += item.approved
                  }
                  if (item.approved > 0) {
                    totalSumAverageBill += item.average_bill_usd * item.approved
                  }
                  if (item.refunded) {
                    totalSumReturn += item.refunded
                  }
                  if (item.shipped) {
                    totalSunShipped += item.shipped
                  }
                  this.rowsDataPopup.push({
                    offer: {
                      value: `${i}`
                    },
                    total: {
                      value: item.total
                    },
                    totalPercent: {
                      value: Helper.percents(totalSumModal, item.total),
                      bgg: Helper.renderGistPart(totalSumModal, item.total, true)
                    },
                    delivered: {
                      value: item.delivered
                    },
                    averageBillPopup: {
                      value: '$ ' + item.average_bill_usd.toFixed(2)
                    },
                    return: {
                      value: item.refunded
                    },
                    returnPercents: {
                      value: Helper.percents(parseFloat(item.approved), item.refunded),
                      bgg: Helper.renderGistPart(item.approved, item.refunded, true)
                    },
                    shipped: {
                      value: item.shipped
                    },
                    buyout: {
                      value: Helper.percents(item.approved, item.paid)
                    }
                  })
                })
                this.footColumnsPopup = {
                  label: {
                    value: this.$root.$t('statistic.in_total')
                  },
                  total: {
                    value: totalSumModal
                  },
                  totalPercent: {
                    value: ``
                  },
                  delivered: {
                    value: totalSumDelivered
                  },
                  averageBillPopup: {
                    value: Helper.averageBillDayCount(totalSumAverageBill, totalSumAccepted)
                  },
                  return: {
                    value: totalSumReturn
                  },
                  returnPercents: {
                    value: `${parseFloat((totalSumReturn / totalSumModal) * 100).toFixed(0)}%`
                  },
                  shipped: {
                    value: totalSunShipped
                  },
                  buyout: {
                    value: `${Helper.percents(totalSumModal, totalSumDelivered)}`,
                    bg: true
                  }
                }
              }
            })
          })
        })
      })
      this.branchStatistics = true
    }
  }
}
</script>

<style>
    .newRow{
        display: flex;
        flex-wrap: nowrap;
        margin-right: -15px;
        margin-left: -15px;
    }
    .cellInput{
        border:none;
        background: transparent;
        text-align: center
    }
    .cellInput:focus{
        text-align: left;
    }
    .cel{
        border: rgba(0, 0, 0, 0.03) 2px solid;
    }
    .card-header-title {
        margin-left: 135px;
        margin-top: 25px;
        padding: 0;
        margin-bottom: 35px;
        font-size: 1.5em;
        text-align: center;
        height: 100%;
    }
    .modal-header_popup {
        display: none;
    }
    .flypost .tr_courier {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// Flypost.vue?43b9ebb4